<template>
  <div>
    <h1>SWIVEL SSO Tester</h1>

    <section>
      <div class="block">
        <h2>iframe</h2>
        <p>Builds pages as an iframe</p>
        <router-link to="/iframe" tag="button">iframe</router-link>
      </div>

      <div class="block">
        <h2>Direct Link [WIP]</h2>
        <p>Redirects user to a direct link to swivelpay</p>
        <router-link to="/direct" tag="button">direct link</router-link>
      </div>
    </section>

    <br/>
  </div>
</template>

<script>
export default {
  name: 'home',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../styles/main.scss';
</style>
